import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { TableSortOption } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_ALL_ISSUES } from 'src/common/providers/reactQueryProvider/QueryKeys';

import { getAllIssues } from '../../../services/all-issues/AllIssuesService';
import { IAllIssuesResult } from '../../../services/queries/all-issues/helpers/transformResults';

export const useAllIssuesData = (
	filters: IFilterOptions,
	page: number,
	sizePerPage: number,
	sort?: TableSortOption,
	enabled = true
): UseQueryResult<IAllIssuesResult> => {
	return useQuery(
		[DASHBOARD_ALL_ISSUES, filters, page, sizePerPage, sort],
		async (): Promise<IAllIssuesResult> => getAllIssues(filters, page, sizePerPage, sort),
		{
			enabled,
			keepPreviousData: true,
			staleTime: 5 * 60 * 1000,
			cacheTime: 10 * 60 * 1000,
			refetchOnWindowFocus: false
		}
	);
};
